export const TECHNICAL_PARAMS = {
    group: 'technical_events',
    sub_group: 'entity_events',
};
